module.exports = __webpack_public_path__ + "img/img1.c2871b43.svg";